var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './SimpleSection';
import '../button/SimpleButton';
import '../table/SimpleTable';
let VariableSection = class VariableSection extends LitElement {
    handleButtonClick(e) {
        this.dispatchEvent(new CustomEvent('variable-section-button-click', { detail: e }));
    }
    getTableData(variables) {
        if (variables.length === 0) {
            return { columns: [], rows: [] };
        }
        const columns = Object.keys(variables[0]);
        const rows = variables.map(variable => {
            const row = {};
            for (const key in variable) {
                row[key] = variable[key];
            }
            return row;
        });
        return { columns, rows };
    }
    render() {
        return html `
      <simple-section .title=${this.title}>
        <div class="section-content">
          <simple-button
            primary
            .label=${this.label}
            @click=${this.handleButtonClick}
          ></simple-button>
          <simple-table .tableData=${this.getTableData(this.variables)}></simple-table>
        </div>
      </simple-section>
    `;
    }
};
VariableSection.styles = css `
    :host {
      display: block;
    }
    .section-content {
      display: flex;
      flex-direction: column;
      gap: 12px; /* Réduction de 25% */
    }
  `;
__decorate([
    property({ type: String })
], VariableSection.prototype, "title", void 0);
__decorate([
    property({ type: String })
], VariableSection.prototype, "label", void 0);
__decorate([
    property({ type: Object })
], VariableSection.prototype, "variables", void 0);
VariableSection = __decorate([
    customElement('variable-section')
], VariableSection);
export { VariableSection };
//# sourceMappingURL=VariableSection.js.map